<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recover your password</h4>
                                    <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                                </div>
                                <span class="text-danger text-sm"  v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                                <vs-input type="email" label-placeholder="Email" v-model="Email" v-validate="'required|email'" name="Email" class="w-full mb-8" />
                                
                                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                                <vs-button @click="before_save" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Recover Password</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
var vm;
export default {
  data () {
    return {
      Email: null
    }
  },
  methods: {
    before_save()
    { 
      return new Promise((resolve, reject) => {
          this.$validator.validateAll().then(result => {
          resolve(result);
          if(result)
            vm.formSubmitted()
        })
      })
    },
    formSubmitted() {
      this.$vs.loading() 
        return new Promise((resolve, reject) => {
          this.$store.dispatch('clientManagement/sendForgetPassMail', { Email: this.Email})
          .then(res => { 
            //alert(res.message)            
            
            this.$vs.loading.close()  
            if (res.status == 200) {
              this.$vs.notify({
                  color: 'success',
                  position: 'top-center',
                  title: 'Forget Password',
                  text: res.message
                })
              //this.$router.push('/event/list');    
            }   
            else if (res.status == 500) {
              this.$vs.notify({
                  color: 'warning',
                  position: 'top-center',
                  title: 'Forget Password',
                  text: res.message
                })
              //this.$router.push('/event/list');    
            }          
          }) 
          .catch(err => { 
          this.$vs.loading.close() 
          })
        })
        
    },
  },
  mounted() {
   if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    vm = this;
  }
}
</script>
